import { Immutable } from "immer";
import React from "react";
import { isoWebPageURL } from "tsi-common-react/src/models/nominals";
import { usePageURL } from "tsi-common-react/src/utils/urls";
import { t } from "ttag";

import type { RetailFeatureBlock as Value } from "@reactivated";

import { RetailLocatorStoreCount } from "../../apps/retail-locator/RetailLocatorStoreCount";

type Props = Immutable<{
    value: Value | null;
}>;

export const RetailFeatureBlock = (_props: Props): React.JSX.Element => {
    // StaticBlock: `value` carries no data, so it is never dereferenced.
    // The legacy template used `{% slugurl 'find-retailer' %}`, which the
    // stearns context processor exposes under the `find_a_retailer` URL key
    // (context_processors.py maps slugs["find-retailer"] -> find_a_retailer).
    const findARetailerURL = usePageURL("find_a_retailer");
    const href = findARetailerURL
        ? isoWebPageURL.unwrap(findARetailerURL)
        : undefined;
    return (
        <section className="retail-feature">
            <svg
                viewBox="0 0 16 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M7.61911 10.4286C9.17079 10.4286 10.4286 9.17071 10.4286 7.61905C10.4286 6.06739 9.17079 4.80952 7.61911 4.80952C6.06744 4.80952 4.80959 6.06739 4.80959 7.61905C4.80959 9.17071 6.06744 10.4286 7.61911 10.4286ZM11.4286 7.61905C11.4286 9.72299 9.72308 11.4286 7.61911 11.4286C5.51515 11.4286 3.80959 9.72299 3.80959 7.61905C3.80959 5.51511 5.51515 3.80952 7.61911 3.80952C9.72308 3.80952 11.4286 5.51511 11.4286 7.61905Z"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M13.1626 10.8632C13.8599 9.53746 14.2381 8.41771 14.2381 7.61905C14.2381 3.96345 11.2746 1 7.61905 1C3.96345 1 1 3.96345 1 7.61905C1 8.41771 1.37815 9.53746 2.07551 10.8632C2.75655 12.158 3.67603 13.5283 4.61284 14.7919C5.54693 16.0519 6.48329 17.1858 7.1873 18.0058C7.34378 18.1881 7.48857 18.3546 7.61905 18.5032C7.74953 18.3546 7.89431 18.1881 8.05079 18.0058C8.7548 17.1858 9.69117 16.0519 10.6253 14.7919C11.5621 13.5283 12.4815 12.158 13.1626 10.8632ZM8.29092 19.2535C10.1521 17.1419 15.2381 11.057 15.2381 7.61905C15.2381 3.41117 11.8269 0 7.61905 0C3.41117 0 0 3.41117 0 7.61905C0 11.057 5.08601 17.1419 6.94718 19.2535C7.36398 19.7264 7.61905 20 7.61905 20C7.61905 20 7.87412 19.7264 8.29092 19.2535Z"
                />
            </svg>
            <h4>{t`Feel It For Yourself`}</h4>
            <p>
                <RetailLocatorStoreCount type="sentence" />
            </p>
            <a href={href}>{t`See List`}</a>
        </section>
    );
};
